import { useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Paper, 
  Divider,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import themee from '../../styles/themes/default';
import { useNavigate } from "react-router-dom";
import {useAppSelector} from "../../stores/store";

const theme = createTheme({
  palette: {
    primary: {
      main: '#3e2723',
    },
    secondary: {
      main: '#e9d4a8',
    },
    text: {
      primary: '#3e2723',
    },
  },
  typography: {
    fontFamily: themee.fonts.apex,
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.2rem',
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: '1.2rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#e9d4a8',
        },
      },
    },
  },
});


export default function KozelMembership() {
  const navigate = useNavigate();
  const {isAuthenticated} = useAppSelector(state => state.auth);

  // Dacă utilizatorul este autentificat, nu afișa componenta
  if (isAuthenticated) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Paper elevation={0} sx={{ minHeight: '45vh', py: 4 }}>
        <Container maxWidth="md">

          <Divider sx={{ my: 6 }} />

          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h4" sx={{ mb: 3, textTransform: 'uppercase', fontFamily: themee.fonts.poplar }}>
              Dorești să te alături comunității?
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Îți poti face cont ușor, doar cu numărul tău de telefon
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              Îți poți invita prietenii să susțină cauza Kozel și strângi puncte pe care le vei putea 
              folosi ulterior pentru a accesa premii Kozel inedite.
            </Typography>
            
            <Button 
              variant="contained" 
              color="primary" 
              size="large" 
              sx={{ px: 4, py: 1, color: '#e9d4a8' }}
              onClick={() => {
                navigate('/register');
              }}
            >
              VREAU SĂ DEVIN MEMBRU
            </Button>
          </Box>
        </Container>
      </Paper>
    </ThemeProvider>
  );
}